module.exports = __webpack_public_path__ + "media/images/setting/Icon8-59a06ee3aeb1ef3ffec6022739c04797.svg";